import React, { Component } from 'react';
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import { Modal, ButtonToolbar, Button } from 'react-bootstrap';
import { TextArea } from 'semantic-ui-react';
import WaveLoading from 'react-loadingg/lib/WaveLoading';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import {
    Link
} from "react-router-dom";
class MyVerticallyCenteredModal extends React.Component {
    constructor() {
        super()
        this.state = {
            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",

            building_no: "",
            doorno: "",
            id: "",
        }
    }
    clearState = () => {
        this.setState({
            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",

            building_no: "",
            doorno: "",
            id: "",
        })
    }
    submitForm = () => {
        // console.log('worked ',this.props);
        // console.log('state ',this.state);

        if (this.state.cpassword === this.state.password) {


            var bodyFormData = new FormData();
            bodyFormData.set('name', this.state.name);
            bodyFormData.set('name_in_arabic', this.state.arname);
            bodyFormData.set('username', this.state.username);
            bodyFormData.set('mobile', this.state.mobile);
            bodyFormData.set('password', this.state.password);
            bodyFormData.set('user_type', 'T');
            bodyFormData.set('email', this.state.email);

            axios.post(
                Base.url + 'User/',
                bodyFormData,
                {
                    headers: {
                        'Authorization': 'Token ' + localStorage.getItem('Token'),
                    }
                }
            )
                .then(response => {
                    // console.log('response : ',response);
                    // console.log('response : ',response.data.id);
                    if (response.data.Status) {

                        // NotificationManager.success( 'response.data.Message','Success : ',3000)

                        var bodyFormDataAddress = new FormData();
                        bodyFormDataAddress.set('building_no', this.state.building_no);
                        bodyFormDataAddress.set('door_no', this.state.doorno);
                        bodyFormDataAddress.set('tenant_id', response.data.id);

                        axios.post(
                            Base.url + 'Address/',
                            bodyFormDataAddress,
                            {
                                headers: {
                                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                                }
                            }
                        )
                            .then(response => {
                                // console.log('response : ',response);
                                if (response.data.Status) {
                                    // console.log("True ",response);

                                    NotificationManager.success(response.data.Message.Message, 'Success : ', 3000)
                                    this.clearState()
                                    this.props.onHide()
                                    // this.props.Refresh()
                                } else {
                                    // console.log("false ",response);
                                    NotificationManager.error('Error : ', response.data.Error, 3000)
                                }
                            })
                            .catch(error => {
                                console.log(error);
                            })

                        // this.clearState()
                        // this.props.onHide()
                        // this.props.Refresh()
                    } else {
                        console.log(response.data.Message);
                        NotificationManager.error(response.data.Message, response.data.Error, 3000)
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        }
        else {

            NotificationManager.info('Info message', 'Close after 2000ms', 3000)
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        // console.log('props ',this.props);

        // const {props} = this.props

        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <NotificationContainer />

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Create Tenant
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <table align="center" >
                        <tr>
                            <td><label>Name</label><input name="name" value={this.state.name} onChange={this.onChange} type="text" className="form form-control" placeholder="Name" /></td>
                            <td><label>Arabic Name</label><input name="arname" value={this.state.arname} onChange={this.onChange} type="text" className="form form-control" placeholder="Arabic Name" /></td>
                        </tr>
                        <tr>
                            <td><label>Username</label><input name="username" value={this.state.username} onChange={this.onChange} type="text" className="form form-control" placeholder="Username" /></td>
                            <td><label>Mobile</label><input value={this.state.mobile} onChange={this.onChange} name="mobile" type="text" className="form form-control" placeholder="Mobile" /></td>
                        </tr>
                        <tr>
                            <td><label>Password</label><input name="password" value={this.state.password} onChange={this.onChange} type="password" className="form form-control" placeholder="Password" /></td>
                            <td><label>Confirm Password</label><input name="cpassword" value={this.state.cpassword} onChange={this.onChange} type="password" className="form form-control" placeholder="Confirm Password" /></td>
                        </tr>
                        <tr>
                            <td colSpan='2'><label>Email</label><input name="email" value={this.state.email} onChange={this.onChange} type="text" className="form form-control" placeholder="Email" /></td>
                        </tr>
                        <tr>
                            <td><label>Building number</label><input name="building_no" value={this.state.building_no} onChange={this.onChange} type="text" className="form form-control" placeholder="Building number" /></td>
                            <td><label>Door number</label><input name="doorno" value={this.state.doorno} onChange={this.onChange} type="text" className="form form-control" placeholder="Door number" /></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.submitForm}>Submit</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

class Items extends Component {
    constructor() {
        super()
        this.state = {
            open: false
        }
    }
    toggle() {
        this.setState({
            open: !this.state.open
        });
    }
    callActivateParentFunction = () => {
        console.log('id ', this.props.quotation.id);
        this.props.ManageUsers(this.props.quotation.id, 'actv')
    }

    callDeactivateParentFunction = () => {
        console.log('id ', this.props.quotation.id);
        this.props.ManageUsers(this.props.quotation.id, 'dactv')
    }

    render() {
        // const {Activate,Deactivate} =this.props
        let data = this.props.quotation
        // console.log('data ',data);


        return (
            <>


                <tr>

                    <th scope="row"><NotificationContainer />Username : {data.user.first_name}<br />اسم المستخدم : {data.ar_name}<br />Email : {data.user.email ? data.user.email : 'No email'}</th>
                    <td>{data.user_type == 'O' ? 'Outsider' : 'Tenant'}</td>
                    <td>{data.mobile}</td>
                    <td>
                        {data.is_active ?
                            <button type="button" style={{ width: 90 }} className="btn btn-sucess btn-sm text-red" onClick={this.callDeactivateParentFunction}>Deactivate</button>

                            :
                            <button type="button" style={{ width: 90 }} className="btn btn-sucess btn-sm text-green" onClick={this.callActivateParentFunction} >Activate</button>

                        }
                    </td>
                    <td>{data.address.length > 0 ?
                        <div className="btn btn-sm" onClick={this.toggle.bind(this)}>{this.state.open ? <i className="fa fa-close text-red" ></i> : <i className="fa fa-info text-blue" ></i>}</div>
                        :
                        <div disabled className=" btn-sm"><i className="fa fa-info text-blue opacity-3" ></i></div>

                    }

                    </td>
                </tr>
                {this.state.open &&
                    (data.address.length > 0) &&
                    data.address.map((item, index) => {
                        // console.log('item ',item);
                        return (
                            <tr key={index} style={{ backgroundColor: 'rgb(231, 231, 231)' }}>

                                <td colSpan={3}>
                                    Address     : {index + 1} <br />
                                    Location    : {item.location} <br />
                                    Street      : {item.streat} <br />
                                    Land mark   : {item.land_mark} <br />
                                    Building no : {item.building_no} <br />
                                    Door no     : {item.door_no} <br />
                                </td>
                                <td colSpan={4}>
                                    <div>
                                        <iframe width={300} height={170} frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src={`https://maps.google.com/maps?q=` + item.latitude + `,` + item.longitude + `&hl=en&z=14&output=embed`}>
                                        </iframe>
                                        <br />
                                    </div>
                                </td>
                            </tr>
                        )
                    })

                }


            </>

        )
    }
}


export default class componentName extends Component {
    constructor() {
        super()
        this.state = {
            data: [],
            next: null,
            prev: null,
            tenant: false,
            outsider: false,

            loading: true,
            modalShow: false,

            filter: null
        }
    }
    loading = (args) => {
        this.setState({
            loading: args
        })
    }

    componentDidMount() {
        this.fetchTenant()
    }

    next = () => {
        // let next = this.state.next;
        // next = next.replace(/^http:\/\//i, 'https://');
        //console.log('next ',this.state.next);
        this.loading(true)
        axios.get(
            this.state.next.replace(/^http:\/\//i, 'https://'),
            //   this.state.next,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response :',response);
            //console.log('Response data.results :',response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false
            })
        })
            .catch(error => {
                //console.log('Error : ',error);
                NotificationManager.error('Error : ', error, 3000);
            })
    }


    prev = () => {
        this.loading(true)
        let prev = this.state.prev;
        prev = prev.replace(/^http:\/\//i, 'https://');
        //console.log('next ',this.state.prev);

        axios.get(
            prev,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            //console.log('Response :',response.data);
            //console.log('Response data.results :',response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false
            })
        })
            .catch(error => {
                //console.log('Error : ',error);
                NotificationManager.error('Error : ', error, 3000);
            })
    }

    fetchAllUsers() {
        this.loading(true)

        axios.get(
            Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                filter: false,
                tenant: false,
                outsider: false,
                loading: false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchTenant = () => {
        this.loading(true)

        // console.log('worked tenant');

        axios.get(
            Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=T',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                tenant: true,
                outsider: false,
                filter: "Tenants",
                loading: false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchOutsiders = () => {
        this.loading(true)

        // console.log('worked outsider');

        axios.get(
            Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=O',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                tenant: false,
                outsider: true,
                loading: false,
                filter: 'Outsiders',
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }
    readAll = () => {
        this.fetchAllUsers()
    }

    createUser = () => {

    }

    // setStatus=(event)=>{
    //     this.setState({
    //       modalShow:true,
    //     })
    // }

    manageUsers = (id, action) => {
        // console.log(action,' : ',id);

        var bodyFormData = new FormData();
        bodyFormData.set('user_id', id);
        bodyFormData.set('action', action);

        axios.patch(
            Base.url + 'User/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
            .then(response => {
                // console.log('response : ',response);
                if (response.data.Status) {
                    NotificationManager.success(response.data.Message, 'Success : ', 3000)
                } else {
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                }
                this.fetchAllUsers()

            })
            .catch(error => {
                NotificationManager.error('Error : ', error, 3000)

            })


    }

    // deactivateUser=(id)=>{
    //     console.log('Worked deactivte ',id);
    //     // this.fetchAllUsers()
    // }

    render() {
        return (
            <div>
                {/* <NotificationContainer/> */}
                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Users" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        {/* Table */}

                        <div className="row">
                            <div className="col">
                                <div className="card shadow">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} className="card-header border-0">
                                        <div style={{ flex: 1, height: '100%' }}>

                                            <h3 className="mb-0">
                                                {this.state.filter && <button className="btn btn-sm bg-translucent-secondary" onClick={this.readAll}>clear filter</button>}
                                                Users
                                                {this.state.filter && <span className="text-muted text-sm">{' / ' + this.state.filter}</span>}
                                            </h3>

                                        </div>
                                        {this.state.loading ? "" :
                                            <div style={{ height: '100%', flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
                                                <style dangerouslySetInnerHTML={{ __html: "\n                        .test1:hover{\n                          background-color: rgb(241, 241, 241);\n                          /* box-shadow: 0px 1px 2px 0px grey; */\n                        }\n                      " }} />
                                                <div className="test1" style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10, backgroundColor: this.state.tenant ? '#6072E4' : 'white', color: this.state.tenant ? 'white' : 'black' }} onClick={this.fetchTenant}>Tenant</div>
                                                <div className="test1" style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10, backgroundColor: this.state.outsider ? '#6072E4' : 'white', color: this.state.outsider ? 'white' : 'black' }} onClick={this.fetchOutsiders}>Outsider</div>
                                            </div>
                                        }
                                        <div style={{ height: '100%', flex: 1, justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                                            <ButtonToolbar>
                                                {/* <Button variant="primary" onClick={this.modalTrigger}>
                                        Launch vertically centered modal
                                        </Button> */}

                                                <MyVerticallyCenteredModal
                                                    show={this.state.modalShow}
                                                    id={this.state.quotaionid}
                                                    status={this.state.quotaionStatus}


                                                    onHide={() => this.setState({ modalShow: false })}
                                                />
                                            </ButtonToolbar>

                                            {/* <button type="button" className="btn btn-sucess btn-6x" data-target="#myModal" onClick={this.setStatus} >+ New User</button> */}
                                            {this.state.prev == null ? <button disabled={true} className="btn btn-sm btn-primary">Prev</button> : <button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                            {this.state.next == null ? <button disabled={true} className="btn btn-sm btn-primary">Next</button> : <button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                        </div>
                                    </div>
                                    {this.state.loading ? <WaveLoading /> :
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">Name (En/Ar)</th>
                                                        {/* <th scope="col">Username</th> */}
                                                        {/* <th scope="col">Email</th> */}
                                                        <th scope="col">Type</th>
                                                        <th scope="col">Mobile</th>
                                                        <th scope="col">Action</th>
                                                        <th scope="col">
                                                            <button className="btn btn-sm"
                                                            // onClick={this.setStatus} 
                                                            > <Link className="nav-link" to="/tenant"><i className="fa fa-plus text-green" /> Create Tenant</Link></button><br />
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {this.state.data.map((data, index) =>
                                                        <Items
                                                            Refresh={this.fetchAllUsers}
                                                            ManageUsers={this.manageUsers}
                                                            // Deactivate={this.deactivateUser} 
                                                            key={index} quotation={data}
                                                        />
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        {/* Footer */}
                        <Footer />
                    </div>
                </div>
            </div>

        );
    }
}
